import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    position: 'relative',
  },
  controlAndLabelWrapper: {
    flexGrow: 1,
    flexBasis: 0,
  },
  newStyleControlAndLabelWrapper: {
    maxWidth: 'unset !important',
    '&>div': {
      width: '100%',
      '&>div': {
        width: '100%',
      },
    },
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    marginBottom: 7,
  },
  controlWrapper: {
    position: 'relative',
    display: 'flex',
  },
  withBulb: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    flexDirection: 'column',
  },
  message: {
    marginBottom: 15,
    width: '100%',
  },
  alert: {
    marginTop: 5,
  },
  compactAlert: {
    color: custom.status.danger.contrastText,
    backgroundColor: 'transparent',
    padding: '0 0 0 15px',
    border: 0,
    fontSize: 12,
    fontWeight: 400,
  },
  tooltip: {
    marginLeft: 10,
  },
  bottomTipMessage: {
    marginTop: 16,
  },
  xs: {
    maxWidth: 150,
  },
  sm: {
    maxWidth: 200,
  },
  md: {
    maxWidth: 280,
  },
  lg: {
    maxWidth: 430,
  },
  xl: {
    maxWidth: 580,
  },
  full: {
    maxWidth: 'none',
  },
}));
